import { HubJsonRpcRequest } from "../../../api/HubJsonRpcRequest";
import { HubApiMethods } from "../../../constants/HubApiMethods";

export type CancelDeletionRequest = {
    token: string
}

type CancelDeletionSuccessResponse = {
    status: number
};

type CancelDeletionErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type CancelDeletionResponse = CancelDeletionSuccessResponse | CancelDeletionErrorResponse;


export function cancelDeletion(token: string): Promise<CancelDeletionResponse> {
    return HubJsonRpcRequest.makeRequest<CancelDeletionResponse, CancelDeletionRequest>(
        HubApiMethods.CANCEL_REMOVE_ACCOUNT,
        { token },
        window.app.deviceIdentifier
    );
}
